import Backbone from 'backbone'
import icon from 'scoreboard/components/icon'
import i18n from 'scoreboard/components/i18n'
import { SHAPE } from '../shape-widget-properties'
import ShapePicker from './shape-picker'

/**
 * View that renders the top-level shape selection item in a bootslide menu;
 * renders the menu item label and the currently selected shape icon
 */
const ShapeLabelView = Backbone.View.extend({
	className: 'shape-label',

	initialize: function (opt) {
		this.listenTo(this.model.properties, 'change:shape',
			this.render.bind(this))
	},

	render: function () {
		let shape = this.model.properties.get('shape')

		this.$el.html(i18n.get('admin.import.performanceChartNode.shape')
			+ icon(`wob-${shape}-solid`))

		return this
	}
})

/**
 * Creates a menu item and submenu for selecting a shape in a bootslide menu
 */
function createShapePickerMenu ({ model, bootslideMenu }) {
	bootslideMenu.onWidgetChange(() => {
		let showMenu =
			// Only show the shape picker if the the shape is actually visible;
			// otherwise, changing the shape won't have any effect
			model.isShapeVisible()
			// #57941 can't change lines to another shape
			&& model.properties.get('shape') !== 'line'

		bootslideMenu.bootslide.toggleItem(SHAPE, showMenu)
	})

	return {
		type: 'value-then-submenu',
		id: 'shape',
		label: i18n.get('admin.import.performanceChartNode.shape'),
		hidden: !model.isShapeVisible(),
		contentView: ShapeLabelView.extend({
			model
		}),
		contentEndpoint: function () {
			var v = new ShapePicker({
				model,
				getSelectedShape: () => model.properties.get('shape'),
				onSelectShape: shape => {
					bootslideMenu.options.widgetUpdater.applyUpdate(widget => {
						widget.setShape(shape)
					}, { types: [ 'shape' ] })
				}
			})

			bootslideMenu.childViews.push(v)

			return v.render().el
		}
	}
}

export default createShapePickerMenu

createShapePickerMenu.__filename__ = 'dashboards/widgets/shape/config/create-shape-picker-menu.js'
